import { QueryClient, queryOptions } from '@tanstack/react-query'
import { LoaderFunction } from 'react-router'
import { getSingleFinancialModel } from '.'
import { useFinancialModelSettingsStore, YearMonth } from '../settings/store/financialModelSettingsStore'
import { Currency } from '@/global/currencies'
import { useSettingsStore } from '@/feature/settings/store/useOrganizationStore'

export const financialModelLoader =
  (queryClient: QueryClient): LoaderFunction =>
  async ({ params }) => {
    const { id: financialModelId } = params
    const { active_workspace, active_company } = useSettingsStore.getState()
    if (!active_workspace || !active_company) {
      return null
    }
    const financialModel = await queryClient.ensureQueryData(
      queryOptions({
        queryKey: [`financial-model`, financialModelId],
        queryFn: () => getSingleFinancialModel(financialModelId!),
        enabled: !!financialModelId
      })
    )

    useFinancialModelSettingsStore.setState({
      settings: {
        [financialModelId!]: {
          general: {
            name: financialModel.name,
            revenue_stream_name: financialModel.revenue_stream_name,
            revenue_stream_type: financialModel.revenue_stream_type
          },
          currency: {
            functionalCurrency: financialModel.functional_currency as Currency
          },
          fiscalYearEnd: {
            companyFiscalYearEnd: financialModel.fiscal_year_end.toString() as YearMonth
          },
          timeframe: {
            historical: {
              isActive: financialModel.historical_data_start_at !== null && financialModel.historical_data_end_at !== null,
              startAt: financialModel.historical_data_start_at ? financialModel.historical_data_start_at : null,
              endAt: financialModel.historical_data_end_at ? financialModel.historical_data_end_at : null
            },
            forecast: {
              isActive: financialModel.forecast_data_start_at !== null && financialModel.forecast_data_end_at !== null,
              startAt: financialModel.forecast_data_start_at ? financialModel.forecast_data_start_at : null,
              endAt: financialModel.forecast_data_end_at ? financialModel.forecast_data_end_at : null
            }
          }
        }
      }
    })
    return queryClient.ensureQueryData(
      queryOptions({
        queryKey: [`financial-model`, financialModelId],
        queryFn: () => getSingleFinancialModel(financialModelId!),
        enabled: !!financialModelId
      })
    )
  }
